import { render, staticRenderFns } from "./item.vue?vue&type=template&id=3856edd6&"
import script from "./item.vue?vue&type=script&lang=coffee&"
export * from "./item.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports